import React from 'react';
import { CarerTypeProps } from './types';
import styles from './Carer.module.css';

const CarerType = ({ showBottomLine, carerType, ...props }: CarerTypeProps) => {
  return (
    <>
      <div className={styles.careTypeTab} onClick={props.onClick}>
        <label className={styles.careTypeTabLabel}>{carerType}</label>
        <div
          className={styles.careTypeBottomLine}
          style={{ display: showBottomLine ? 'block' : 'none' }}
        />
      </div>
    </>
  );
};

export default CarerType;
